import './App.css';
import ActivityLog from './ActivityLog/ActivityLog'; 
function App() {
  return (
    <div className="App">
      <header className="App-header">
        <ActivityLog />
      </header>
    </div>
  );
}

export default App;

